import { z } from 'zod';
import type { AddressCardData } from '../../../components/address-card/address-card.component';

export const AddressSchema = z.object({
  FlatNo: z.string().optional(),
  BuildingName: z.string().optional(),
  StreetAddress: z.string().optional(),
  Town: z.string().optional(),
  County: z.string().optional(),
  Country: z.string().optional(),
  ConstituentCountry: z.string().optional(),
  PostCode: z.string(),
  Address1: z.string().optional(),
  Address2: z.string().optional(),
  Address3: z.string().optional(),
  Address4: z.string().optional(),
  ResidentialStatus: z.string().nullable().optional(),
});
export type Address = z.infer<typeof AddressSchema>;

export const ClientAddressItemSchema = z.object({
  AddressId: z.number(),
  Address: AddressSchema,
  IsCurrentResidentialAddress: z.boolean(),
  DateMovedToAddress: z.string().datetime().optional().nullable(), // Accept string, null, or undefined for legacy data
  DateMovedFromAddress: z.string().datetime().optional().nullable(),
  ResidentialStatus: z
    .union([z.number(), z.string()])
    .nullable()
    .optional()
    .transform((val) => {
      if (typeof val === 'string' && !isNaN(Number(val))) {
        return Number(val);
      }
      return val;
    }),
});
export type ClientAddressItem = z.infer<typeof ClientAddressItemSchema>;

export const ClientAddressHistorySchema = z.array(ClientAddressItemSchema);
export type ClientAddressHistory = z.infer<typeof ClientAddressHistorySchema>;

export interface AddressExtractionResult {
  currentAddress: ClientAddressItem | null;
  addressHistory: ClientAddressItem[];
  dateOfBirth?: string;
}

export interface AddressCollectionSummary {
  totalAddresses: number;
  hasCurrentAddress: boolean;
  earliestMoveInDate: Date | null;
  collectedAddressCards: AddressCardData[];
}
